import React from 'react';
import { PageLayout, PageLayoutProps } from '../../PageLayout';

export interface LoadingPageProps extends PageLayoutProps {}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  ...pageLayoutProps
}) => {
  return <PageLayout textAlign="center" {...pageLayoutProps} />;
};
